import React from "react"
import PropTypes from "prop-types"

let UserContext
const { Provider, Consumer } = (UserContext = React.createContext())

class UserProvider extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      user: null,
      verified: null,
      onLogin: this.handleLogin,
      onLogout: this.handleLogout,
    }
  }

  handleLogin = (user) => {
    this.setState({ user })
  }

  handleLogout = () => {
    this.setState({ user: null })
  }

  render() {
    return <Provider value={this.state}>{this.props.children}</Provider>
  }
}

UserProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export { UserProvider, Consumer as UserConsumer, UserContext }
